import { useId } from 'react'

import { Badge, type BadgeTone } from '@/design'

/**
 * A badge whose full explanation lives in a tooltip and an accessible
 * description, rather than on the page — the shape every provenance badge
 * needs (Advertising's source, provider and TmT badges; Attribution's metric
 * sources), so another one is one call, not another copy of the wrapping
 * `<span>`/`useId`/`aria-describedby` block.
 */
export function TooltipBadge({
  tone,
  label,
  tooltip,
  className,
}: {
  tone: BadgeTone
  label: string
  tooltip: string
  className: string
}) {
  const captionId = useId()
  return (
    <span title={tooltip} tabIndex={0} aria-describedby={captionId} className={className}>
      <Badge tone={tone}>{label}</Badge>
      <span id={captionId} className="ci-visually-hidden">
        {tooltip}
      </span>
    </span>
  )
}
